import { pick } from 'lodash/fp';
import pickBy from 'lodash/pickBy';

import config from '@config';

import createDataSource from './createDataSource';
import { getDefaultEmptyList, getDefaultListHandler, makeGetByIds } from './utils';

const BASE_PATHNAME = 'videos';

export const PLAYLIST_FILTER_KEY = 'videoPlaylistId';

export const SORT_OPTION = {
  SAVED: {
    key: '-modified',
    label: 'Date saved',
  },
  ALPHABETICALLY: {
    key: 'title',
    label: 'Alphabetically',
  },
};
export const DEFAULT_SORT = SORT_OPTION.SAVED;
export const SORT_OPTIONS = Object.values(SORT_OPTION);

export default () => {
  const dataSource = createDataSource(config.api.url);

  const getById = ({ id }) => dataSource.get(`${BASE_PATHNAME}/${id}`).json();
  // const getByIds = ({ ids, locale }) => Promise.all(ids.map((id) => getById({ id })));
  const getByIds = makeGetByIds({ dataSource, url: `${BASE_PATHNAME}/getmany` });

  const remove = ({ id }) => dataSource.delete(`${BASE_PATHNAME}/${id}`);

  const create = ({ values }) => dataSource.post(BASE_PATHNAME, { json: { ...values } }).json();
  const update = ({ id, values }) => dataSource.put(`${BASE_PATHNAME}`, { json: { ...values, id } }).json();

  const save = async ({ id, values }) => (id ? update({ id, values }) : create({ values }));

  const publish = async ({ id, values, dateTime }) => {
    const video = await save({ id, values });

    if (video.language) {
      return dataSource
        .put(`${BASE_PATHNAME}/${video.id}/${video.language}/publish`, { searchParams: pickBy({ dateTime }) })
        .json();
    }

    return dataSource.put(`${BASE_PATHNAME}/${id}/publish`, { searchParams: pickBy({ dateTime }) }).json();
  };

  const unpublish = ({ id, language }) => {
    return dataSource.put(`${BASE_PATHNAME}/${id.split('_')[0]}/${language}/unpublish`).json();
  };

  return {
    getList: getDefaultListHandler({
      transformFilter: pick(['videoPlaylistId']),
      url: BASE_PATHNAME,
      dataSource,
    }),
    unpublish,

    getByIds,

    publish,

    getById,

    remove,

    create,

    update,

    save,

    getEmptyList: getDefaultEmptyList,
  };
};
